<script setup lang="ts">
import { ThemeSetting } from '#imports';

const { t } = useEkI18n();
const settingsStore = useSettingsStore();

const options = [
  ThemeSetting.system, 
  ThemeSetting.light,
  ThemeSetting.dark,
  ThemeSetting.darkHighContrast
];

async function updateTheme(theme: ThemeSetting) {
  await settingsStore.set('theme', theme);
}
</script>

<template>
  <SettingsSelect 
    :options="options"
    :label="t('settings.general.theme')"
    :placeholder="settingsStore.settings.theme"
    :value="settingsStore.settings.theme"
    :resolve-key="(o: ThemeSetting)=>o"
    @change="updateTheme"
  >
    <template #option="{option}">
      {{ t("settings.general.themeOptions." + option) }}
    </template>
  </SettingsSelect>
</template>

<style scoped>
</style>
